import template from './users-detail.html';
import controller from './users-detail.controller';
import './users-detail.styl';

const usersDetailComponent = {
  template,
  controller,
  controllerAs: 'usersDetail',
  require: {
    app: '^^app'
  }
};

export default usersDetailComponent;


/** WEBPACK FOOTER **
 ** ./frontend/components/admin/users/users-detail/users-detail.component.js
 **/